// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title-description-list__wrapper .title-description-list__item-title[data-v-d5ce67da]{margin-bottom:8px}.title-description-list__wrapper .title-description-list__item-description[data-v-d5ce67da]{color:#a3a5a6}", ""]);
// Exports
module.exports = exports;
